module.exports = __webpack_public_path__ + "img/logo.80e458f7.png";